/* HBP free-shipping bar (snippets/hbp-ship-bar.liquid). Every bar on the page follows the cart
   total from hb-box-cart.js (hb:cart:updated). The suggestion row shows 3 products that each unlock
   free shipping on their own: the bar's dips plus the flavor packs from /products.json, cheapest
   first; if fewer than 3 can, the closest ones fill the row. Adds go through HBBoxCart so the drawer refreshes. */
(() => {
  if (window.HBSB) return;
  const money = c => '$' + (c / 100).toFixed(2);
  const esc = s => String(s ?? '').replace(/[&<>"]/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  // Flavor packs that can be suggested alongside the dips.
  const PACK = /(-soft-pretzel-bites-(2|4)-pack|^pb-j-bundle-2-pack|-sampler-soft-pretzel-bites-8-pack|^soft-pretzel-bites-sampler-10-pack)$/;
  let total = typeof window.HBSB_CART === 'number' ? window.HBSB_CART : 0;
  let count = null;
  let packs = [];

  fetch(root + 'products.json?limit=250', {credentials: 'same-origin'})
    .then(r => r.ok ? r.json() : {products: []})
    .then(d => {
      packs = (d.products || []).filter(p => PACK.test(p.handle)).map(p => {
        const v = p.variants.filter(x => x.available).sort((a, b) => parseFloat(a.price) - parseFloat(b.price))[0];
        return v && {id: v.id, title: p.title, price: Math.round(parseFloat(v.price) * 100), url: root + 'products/' + p.handle, img: p.images[0] ? p.images[0].src + (p.images[0].src.includes('?') ? '&' : '?') + 'width=300' : ''};
      }).filter(Boolean);
      paintAll();
    }).catch(() => {});

  function pick(recs, left) {
    const seen = new Set(), pool = recs.concat(packs).filter(r => !seen.has(r.id) && seen.add(r.id));
    const unlock = pool.filter(r => r.price >= left).sort((a, b) => a.price - b.price);
    const below = pool.filter(r => r.price < left).sort((a, b) => b.price - a.price);
    return unlock.concat(below).slice(0, 3);
  }

  function paint(bar) {
    const goal = +bar.dataset.goal || 7500;
    const left = Math.max(goal - total, 0);
    const done = left === 0;
    if (bar.dataset.place === 'drawer' && count !== null) bar.hidden = count === 0;
    bar.classList.toggle('is-done', done);
    bar.querySelector('[data-hbsb-fill]').style.width = Math.min(total / goal, 1) * 100 + '%';
    bar.querySelector('[data-hbsb-msg]').innerHTML = done ? 'You unlocked <em>free shipping!</em>' : `Add <em>${money(left)}</em> to unlock free shipping`;
    let recs = [];
    try { recs = JSON.parse(bar.querySelector('[data-hbsb-recs]').textContent); } catch (e) {}
    const list = bar.querySelector('[data-hbsb-list]'), title = bar.querySelector('[data-hbsb-title]');
    const items = done ? [] : pick(recs, left);
    // PDP: row starts closed behind "See what to add"; cart drawer: always open.
    const toggle = bar.querySelector('[data-hbsb-toggle]');
    const open = !toggle || toggle.getAttribute('aria-expanded') === 'true';
    if (toggle) toggle.hidden = !items.length;
    list.hidden = title.hidden = !items.length || !open;
    title.textContent = items.length && items.every(r => r.price >= left) ? 'Add one to unlock free shipping' : 'Get closer to free shipping';
    list.innerHTML = items.map(r => `<div class="hbsb__item">${r.img ? `<img src="${esc(r.img)}" alt="" loading="lazy" width="150" height="150">` : ''}<a href="${esc(r.url)}">${esc(r.title)}</a><p>${money(r.price)}${r.price >= left ? '<b>Unlocks free shipping</b>' : `<b>${money(left - r.price)} to go after</b>`}</p><button type="button" data-hbsb-add="${r.id}" aria-label="Add ${esc(r.title)}">Add</button></div>`).join('');
  }
  const paintAll = () => document.querySelectorAll('[data-hbsb]').forEach(paint);

  document.addEventListener('click', e => {
    const t = e.target.closest('[data-hbsb-toggle]');
    if (t) { t.setAttribute('aria-expanded', t.getAttribute('aria-expanded') !== 'true'); paint(t.closest('[data-hbsb]')); return; }
    const add = e.target.closest('[data-hbsb-add]');
    if (!add) return;
    add.disabled = true; add.textContent = 'Adding…';
    const body = {items: [{id: +add.dataset.hbsbAdd, quantity: 1}]};
    const req = window.HBBoxCart ? window.HBBoxCart.add(body, add) : fetch(root + 'cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify(body)}).then(() => fetch(root + 'cart.js')).then(r => r.json()).then(c => { total = c.total_price; count = c.item_count; paintAll(); });
    Promise.resolve(req).catch(() => {}).finally(() => { add.disabled = false; add.textContent = 'Add'; });
  });
  ['hb:cart:updated', 'cart:updated'].forEach(n => document.addEventListener(n, e => {
    const c = e.detail && e.detail.cart;
    if (c && typeof c.total_price === 'number') { total = c.total_price; count = c.item_count; paintAll(); }
  }));
  window.HBSB = {paint: paintAll};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paintAll); else paintAll();
  document.addEventListener('shopify:section:load', paintAll);
})();
